import type { UserClaims } from '../services/user';

export const MOCK_USER_KEY: Readonly<string> = 'my_group_user';

export const MOCK_USER: Readonly<UserClaims> = {
  name: 'Ben Entou Antaster',
  jobTitle: 'Pedagogisch Medewerk(st)er',
};
